import React from 'react';

import { BrowserRouter as Router } from 'react-router-dom';

import GlobalContext from 'context';
import GlobalStyle from './styles/GlobalStyles';
import RouteList from './routes/routes';
import Header from './components/layout/header/Header';
import MainSearch from 'components/layout/main-search/MainSearch';
import Footer from 'components/layout/footer/Footer';
import ScrollToTop from 'components/layout/scroll-to-top/ScrollToTop';
import { PageWrapper } from 'styles/Layout';

function App() {
	return (
		<>
            <GlobalContext>
                <GlobalStyle />
                <Router>
                    <PageWrapper>
                        <Header />
                        <MainSearch />
                        <RouteList />
                        <Footer />
                        <ScrollToTop />
                    </PageWrapper>
                </Router>
            </GlobalContext>
		</>
	);
}

export default App;